import {Box, Typography, styled} from '@mui/material';
import PropTypes from 'prop-types';
import React, {useEffect, useRef, useState} from 'react';

const StyledTypography = styled(Typography, {
  shouldForwardProp: prop => prop !== 'pxOverflow',
})(({pxOverflow}) => ({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  transformOrigin: 'inherit',
  textOverflow: 'ellipsis',
  transform: 'translateX(0)',
  transition: `transform calc(0.006s * ${pxOverflow}) linear`,
  '&:hover': {
    transition: `transform calc(0.012s * ${pxOverflow}) linear`,
    transform: `translateX(-${pxOverflow}px)`,
  },
}));

const ScrollingTitle = ({children, ...props}) => {
  const [overflow, setOverflow] = useState(0);
  const [isMouseOver, setMouseOver] = useState(false);
  const elemRef = useRef();

  const isElementOverflowing = element => {
    if (element) {
      setOverflow(element.scrollWidth - element.offsetWidth);
      elemRef.current = element;
    }
  };

  useEffect(() => {
    const restoreStyle = function () {
      elemRef.current.style.overflow = 'hidden';
    };
    if (elemRef.current && !isMouseOver) {
      elemRef.current.addEventListener('transitionend', restoreStyle);
    }
    return () => {
      elemRef.current.removeEventListener('transitionend', restoreStyle);
    };
  }, [isMouseOver]);

  return (
    <Box
      sx={{
        width: '100%',
        overflow: 'hidden',
      }}
    >
      <StyledTypography
        pxOverflow={overflow}
        ref={isElementOverflowing}
        onMouseEnter={() => {
          if (elemRef.current) {
            elemRef.current.style.overflow = 'visible';
          }
          setMouseOver(true);
        }}
        onMouseLeave={() => setMouseOver(false)}
        {...props}
      >
        {children}
      </StyledTypography>
    </Box>
  );
};

ScrollingTitle.propTypes = {
  children: PropTypes.string,
};

export default ScrollingTitle;
